import {HVBoxChildModel} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/layouts/hvbox/HVBoxChildModel';
import {PositioningType} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/layouts/PositioningType';
import {Property} from '@mintdata/mint-kit/api/decorators/Property';
import {Offsets} from '@mintdata/mint-kit/api/models/Offsets';
import {AStringEnumConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/AEnumConfig';
import {BeanConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/BeanConfig';
import {OffsetsConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/OffsetsConfig';

export class LayoutModel
{
    @Property<PositioningType>({
        title: 'Positioning Type',
        tip: 'Positioning Type',
        isRequired: true,
        typeConfig: AStringEnumConfig,
        typeCtor: PositioningType
    })
    public positioningType:PositioningType;

    @Property<Offsets>({
        title: 'Margin',
        tip: 'Margin',
        isRequired: false,
        typeConfig: OffsetsConfig,
        typeCtor: Offsets
    })
    margin:Offsets;

    @Property<Offsets>({
        title: 'Margin',
        tip: 'Margin',
        isRequired: false,
        typeConfig: OffsetsConfig,
        typeCtor: Offsets
    })
    marginFirst:Offsets;

    @Property<Offsets>({
        title: 'Margin',
        tip: 'Margin',
        isRequired: false,
        typeConfig: OffsetsConfig,
        typeCtor: Offsets
    })
    marginLast:Offsets;

    @Property<HVBoxChildModel>({
        title: 'HBox/VBox Child model',
        tip: 'HBox/VBox Child model',
        isRequired: true,
        typeConfig: BeanConfig,
        typeCtor: HVBoxChildModel
    })
    public hvBox:HVBoxChildModel;

    public constructor(positioningType:PositioningType = PositioningType.selfDirected(),
                       margin:Offsets = Offsets.fromEqualPixels(0),
                       marginFirst:Offsets = Offsets.fromEqualAuto(),
                       marginLast:Offsets = Offsets.fromEqualAuto(),
                       hvBox:HVBoxChildModel = new HVBoxChildModel())
    {
        this.positioningType = positioningType;
        this.margin = margin;
        this.marginFirst = marginFirst;
        this.marginLast = marginLast;
        this.hvBox = hvBox;
    }
}
